import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'deliveryId' })
export class DeliveryIdPipe implements PipeTransform {
  transform(id: number | string): string {
    return `00000000${id}`.slice(-8);
  }
}
